module.exports = __webpack_public_path__ + "img/default-comlogo.f423a851.png";